<template>
  <v-card flat color="#161616" class="rounded-xl pa-8 border-yt">
    <div class="section-title mb-2">
      <v-icon small color="#3ea6ff" class="mr-2">mdi-truck-outline</v-icon>
      Proveedores
    </div>
    <div class="caption grey--text mb-6">
      A quién se le compra este producto, cómo lo llama cada proveedor y el
      último costo al que se compró (sin IVA). Se completa solo con cada compra.
    </div>

    <v-progress-linear v-if="loading" indeterminate color="#3ea6ff" />

    <div v-else-if="!vinculos.length" class="caption grey--text">
      Todavía no se le compró a ningún proveedor.
    </div>

    <v-simple-table v-else dense dark class="transparent">
      <thead>
        <tr>
          <th>Proveedor</th>
          <th>Presentación</th>
          <th>Código / descripción del proveedor</th>
          <th class="text-right">Último costo</th>
          <th>Fecha</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="v in vinculos" :key="v.id">
          <td>{{ v.proveedor }}</td>
          <td>{{ v.presentacion }}</td>
          <td>
            <span v-if="v.codigo" class="mono-font">{{ v.codigo }}</span>
            <span v-if="v.codigo && v.descripcion_proveedor"> · </span>
            <span class="grey--text">{{ v.descripcion_proveedor }}</span>
          </td>
          <td class="text-right">{{ v.ultimo_costo !== null ? pesos(v.ultimo_costo) : "—" }}</td>
          <td>{{ fecha(v.fecha_ultimo_costo) }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-card>
</template>

<script>
export default {
  name: "ProductoEmpresaProveedores",
  data() {
    return { vinculos: [], loading: false };
  },
  methods: {
    pesos(valor) {
      return Number(valor).toLocaleString("es-AR", { style: "currency", currency: "ARS" });
    },
    fecha(valor) {
      return valor ? new Date(valor).toLocaleDateString("es-AR") : "—";
    },
    async fetch() {
      this.loading = true;
      try {
        const { data } = await this.axios.get(
          `/productos/productos/${this.$route.params.id_producto}/proveedores`
        );
        this.vinculos = data;
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.fetch();
  },
};
</script>
